<template>
  <div>
    <div class="lib__form__main">
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__text-danger">
            <b>{{$t('maintenance.title')}}</b>
          </h2>
        </header>
        <p v-html="$t('maintenance.message')"></p>
      </div>
    </div>

    <!-- <div class="lib__form__announcement">
      <h2 class="lib__text-danger">
        <i class="far fa-times-circle"></i>
        <b>Maintenance en cours</b>
      </h2>
      <p class="lib__text">
        Cher client,<br />
        Nos services sont indisponibles jusqu’au 29 novembre.<br />
        Veuillez nous excuser pour ce désagrément.
      </p>
    </div> -->
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { localize } from 'vee-validate'

@Component({
  name: 'maintenance'
})
export default class Maintenance extends Vue {
  //#region [Property]
  @Prop({ type: String, required: false }) public readonly form!: string | null
  @Prop({ type: String, required: true }) public readonly lang!: string
  //#endregion

  //#region [Watch]
  @Watch('lang')
  public onLangChanged(value: string) {
    this.$i18n.locale = value
    localize(value)
    this.$store.commit('SET_LANGUAGE', value)
  }
  //#endregion
}
</script>
